import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "w-full h-0 fixed top-0 left-0 overflow-visible",
  style: {"z-index":"990"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_content_wrapper = _resolveComponent("modal-content-wrapper")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_modal_content_wrapper, _mergeProps(_ctx.$props, {
        "onUpdate:visible": _cache[0] || (_cache[0] = (v) => _ctx.$emit('update:visible', v)),
        onCancel: _cache[1] || (_cache[1] = () => _ctx.$emit('cancel')),
        onOk: _cache[2] || (_cache[2] = () => _ctx.$emit('ok'))
      }), null, 16)
    ])
  ]))
}